import { Component } from "@angular/core"
import { TitleService } from "@puntaje/shared/core"

@Component({
    templateUrl: "./typeform-widgets.component.html",
    styleUrls: ["./typeform-widgets.component.scss"]
})
export class TypeformWidgetsComponent {}
